import type { VisualPromptSingleSelectStep } from '@/types/visualPrompts/visualPrompt.types';

export const MATTER_RELATED_YES_LABEL = 'Yes — matter or client context';
export const MATTER_RELATED_NO_LABEL = 'No — general firm-wide comms';

export const MATTER_RELATED_STEP: VisualPromptSingleSelectStep = {
  id: 'matter-related',
  type: 'singleSelectPills',
  title: 'Is this matter-related?',
  description:
    'Helps the assistant handle confidentiality and client-identifying detail appropriately.',
  mapsTo: 'matterRelated',
  required: true,
  options: [
    { id: 'yes', label: MATTER_RELATED_YES_LABEL },
    { id: 'no', label: MATTER_RELATED_NO_LABEL },
  ],
};
